// CDC i18n messages — namespace isolado `CDC.*` para evitar colisão com chaves upstream.
// Vazio por design: features CDC preenchem seu próprio sub-namespace (a primeira é
// `CDC.WAVOIP.*` pela ADR 0007). Mantido fora de `en.yml`/`en.json` (core upstream).
// Origem: ADR 0006.

export default {
  en: {
    CDC: {
      WAVOIP: {
        admin: {
          label: 'WAVOIP Token',
          placeholder: 'Paste the token…',
          helper: "Token generated in the agent's WAVOIP panel",
          save_button: 'Save token',
          save_success: 'Token saved',
          save_error: 'Failed to save token',
          reveal: 'Show',
          hide: 'Hide',
        },
        button: {
          tooltip: 'Call via WhatsApp',
          disabled_busy_wavoip: 'A WAVOIP call is already in progress',
          disabled_busy_twilio: 'End the Twilio call before calling via WAVOIP',
        },
        widget: {
          dialing: 'Calling {phone}…',
          in_call: 'In call — {timer}',
          end_button: 'End call',
        },
        toast: {
          reject: 'Call rejected',
          unanswered: 'No answer',
          error_generic: 'Call error',
          signaling_timeout: 'Connection timeout',
        },
      },
      CARD_SEARCH: {
        tooltip: 'Search in dashboard',
        combo_tooltip: 'Find customer in card dashboard',
        toast: {
          not_found: 'No customer found',
          error: 'Card dashboard search failed',
        },
        modal: {
          title: 'Select a customer',
          inactive_badge: 'inactive',
          dependant_badge: 'dependant',
        },
      },
    },
  },
  pt_BR: {
    CDC: {
      WAVOIP: {
        admin: {
          label: 'Token WAVOIP',
          placeholder: 'Cole o token…',
          helper: 'Token gerado no painel WAVOIP do agente',
          save_button: 'Salvar token',
          save_success: 'Token salvo',
          save_error: 'Falha ao salvar o token',
          reveal: 'Mostrar',
          hide: 'Ocultar',
        },
        button: {
          tooltip: 'Ligar via WhatsApp',
          disabled_busy_wavoip: 'Já existe uma chamada WAVOIP em andamento',
          disabled_busy_twilio:
            'Encerre a chamada Twilio antes de ligar via WAVOIP',
        },
        widget: {
          dialing: 'Ligando para {phone}…',
          in_call: 'Em chamada — {timer}',
          end_button: 'Encerrar',
        },
        toast: {
          reject: 'Chamada recusada',
          unanswered: 'Sem resposta',
          error_generic: 'Erro na chamada',
          signaling_timeout: 'Tempo de conexão excedido',
        },
      },
      CARD_SEARCH: {
        tooltip: 'Procurar no dashboard',
        combo_tooltip: 'Localizar cliente no dashboard card',
        toast: {
          not_found: 'nenhum cliente encontrado',
          error: 'Falha na busca no dashboard',
        },
        modal: {
          title: 'Selecione um cliente',
          inactive_badge: 'inativo',
          dependant_badge: 'dependente',
        },
      },
    },
  },
};
